import moment from 'moment';
import usePeriods from '../../../state/hooks/usePeriods';
import Icon from 'components/base/Icon';
import { Flex } from 'components/base/layout-components';
import { Tooltip } from '@material-ui/core';
import { StyledPeriod } from './Period.style';
import { SEARCH_DATE_FORMAT } from 'common/constants/constants';

const formatDate = d => moment(d).format(SEARCH_DATE_FORMAT);
const formatPeriodToString = period =>
  `${formatDate(period.after)} - ${formatDate(period.before)}`;

const Period = () => {
  const { periods, lastPeriod, restorePeriod } = usePeriods();
  const isCustomPeriod = periods.length > 1;

  const restorePeriodStr = `Restore period to default: ${formatPeriodToString(
    periods[0]
  )}`;

  return (
    <StyledPeriod>
      {formatPeriodToString(lastPeriod)}
      {isCustomPeriod && (
        <Tooltip title={restorePeriodStr} placement='top'>
          <Flex className='refreshButton' items='center' justify='center'>
            <Icon
              name='Refresh'
              size='smaller'
              color='white'
              onClick={restorePeriod}
            />
          </Flex>
        </Tooltip>
      )}
    </StyledPeriod>
  );
};

export default Period;
